import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
  Fab,
} from "@material-ui/core";
import AlarmsTable from "./AlarmsTable";
import AddIcon from "@material-ui/icons/Add";
import { usePageStyles } from "../../pageStyles";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { useAlarmData } from "../../../data/surveillance/alarmParameters/hooks/useAlarmData";
import { useAlarmIndex } from "../../../data/surveillance/alarmParameters/hooks/useAlarmIndex";
import { useHistory } from "react-router-dom";
import { getAlarmsEditLocation } from "./Locations";
import { PageDataStatus } from "../../../data/models";
import { AlarmFilterButton } from "./AlarmsFilter";
import { useAuth } from "../../../data/auth/hooks";

const AlarmsPage: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  const [pageData, dispatchLoadAlarm] = useAlarmData();
  const [pageIndex, dispatchSetIndex] = useAlarmIndex();

  React.useEffect(() => {
    if (pageData && pageData.status === PageDataStatus.DataInvalidated) {
      dispatchLoadAlarm();
    }
  }, [dispatchLoadAlarm, pageData]);

  const history = useHistory();

  const [auth] = useAuth();

  if (auth.status !== "successful") {
    return null;
  }


  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="alarmTitle" />}
              action={<AlarmFilterButton />}
            />
            <Divider />
            <CardContent>
              <AlarmsTable
                pageIndex={pageIndex}
                pageData={pageData}
                onPageIndexChange={dispatchSetIndex}
                userAccessRights={userAccessRights}
                getData={dispatchLoadAlarm}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      {userAccessRights === AccessRights.All && (
          <Fab
            color="secondary"
            aria-label="add"
            className={pageStyles.mainFab}
            onClick={() => history.push(getAlarmsEditLocation())}
          >
            <AddIcon />
          </Fab>
        )}
    </>
  );
};

export default AlarmsPage;
